import styled from 'styled-components';
//playfairDisplayExtraBold
export const Main = styled.div`
  font-family: 'playfairDisplayExtraBold', sans-serif;
  // margin-bottom: 100px;
  display: flex;
  height: 1300px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.font1};
  background-image: url(${({ theme }) => theme.aboutBg3});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media (max-width: 900px) {
    height: 1400px;
    // padding-bottom: 20vh;
  }
  h1 {
    font-family: 'Roboto Bold', sans-serif;
    font-weight: bold; /* Define o texto como negrito */
    color: ${({ theme }) => theme.font3};
    font-size: 15px;
  }
`;

export const Section = styled.section`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  gap: 5rem;
  color: ${({ theme }) => theme.font2};
  // width: 800px;

  @media (max-width: 1210px) {
  }

  @media (max-width: 900px) {
    // margin-top: 80px;
  }
`;

export const TextHorizontal = styled.div`
  display: flex;
  gap: 3rem;
  // div h1 {
  //   display: flex;
  //   align-items: center;
  //   height: 100px;
  //   // width: 350px;
  // }
  // div p {
  //   display: flex;
  //   // align-items: center;
  //   height: 150px;
  //   width: 350px;
  // }

  img {
    width: 35px;
    filter: brightness(0) saturate(100%) invert(100%);
  }
  hr {
    width: 50px;
    // height: 5px;
    background-color: '#FFFFFF';
  }
  div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 350px;
  }
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const ButtonDiv = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 5rem;
  // margin-top: 2rem;
  a {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.background2};
    color: ${({ theme }) => theme.font2};
    border: none;
    border-radius: 15px;
    width: 250px;
    height: 50px;
    transition: 0.3s;
  }

  a:hover {
    background-color: ${({ theme }) => theme.font1};
    box-shadow: 0 0 0 5px ${({ theme }) => theme.border};
    color: #fff;
  }
`;
export const Span = styled.span`
  color: ${({ theme }) => theme.font2};
  img {
    width: 70px;
  }
`;

export const TextDiv = styled.div`
  color: ${({ theme }) => theme.font4};
section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
p {
  // text-align: justify;
  font-family: 'Roboto Regular', sans-serif;
  font-size: 15px;
  line-height: 25px;
    // letter-spacing: 1px; /* Aumenta o espaço entre as letras */
}
display: flex;
flex-direction: column;
gap: 4rem;
align-items: center;
justify-content: center;
// width: 990px;
// max-width: 900px;
font-size: 140%;
transition: 0s;
// text-align: left;

h3 {
  font-size: 68px;
}

h4 {
  font-size: 10px;
  font-family: 'Roboto Bold', sans-serif;
}

@media (max-width: 1210px) {
  max-width: 600px;
font-size: 120%;
}

@media (max-width: 900px) {
  max-width: 300px;
font-size: 15px;

.line-1 {
  font-size: 25px;
}
}

@media (min-width: 800px) {

.line-1 {
  font-size: 50px;
}
}

.line-1 {
  top: 50%;
  color: ${({ theme }) => theme.font2};
  margin: 0 auto;
  border-right: 2px solid rgba(255, 255, 255, 0.75);
  margin: 0 auto;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

div {
// display: flex;
// flex-direction: flex
  // gap: rem;
}

/* Animation */
.anim-typewriter {
  animation: typewriter 2s steps(20) 0.5s 1 normal both,
    blinkTextCursor 500ms steps(44) infinite normal;
}

@keyframes typewriter {
  from {
    width: 0;
  }

  to {
    width: 11em;
  }
}

@keyframes blinkTextCursor {
  from {
    border-right-color: ${({ theme }) => theme.background2};
  }

  to {
    border-right-color: transparent;
  }
`;

export const Logo = styled.div`
  position: relative;
  display: inline-block;
  width: 70vh;
  height: 25vh;
  background-image: url(${({ theme }) => theme.logo});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  @media (max-width: 900px) {
    width: 50vh;
    height: 25vh;
  }
`;

export const Switch = styled.div`
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 51px;
    height: 24px;
    background-color: ${({ theme }) => theme.font3};
    border-radius: 34px;
    background-image: url(${({ theme }) => theme.moon});
    background-position: ${({ theme }) =>
      theme.theme === 'light' ? 'left' : 'right'};
    background-repeat: no-repeat;
    background-size: 25px 25px;
  }
`;

export const Card = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
  align-items: center;
  img {
    width: 350px;
  }
  div {
    // padding: 2rem;
    display: flex;
    // flex-direction: flex;
  }
`;

export const borderCard = styled.div`
  // border: 1px solid white; /* 2px de largura, estilo sólido e cor preta */
  border-radius: 2px;
  width: 100%;
  display: flex;
  gap: 3rem;
  
  // flex-direction:
  align-items: center;
  justify-content: space-between;
    img {
    width: 450px;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 100%;
    div {
      display: flex;
      flex-direction: column;
      width: 550px;
      justify-content: right;
      // border: 0px;
    }
`;

export const divP = styled.div`
  display: flex;
  flex-direction: column;
  // height: 100%;
  // align-itens: right;
  // justify-content: left;
  width: 500px;
  gap: 1rem;
  color: ${({ theme }) => theme.font2};
  @media (max-width: 1000px) {
  // height: 900px;
    width: 75%;
    // p {
    //   width: 50px;
    // }
}
  button {
    font-family: 'Roboto Regular', sans-serif;
    font-size: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 3px;
    width: 300px;
    font-size: 14px;
    // background-color: ${({ theme }) => theme.background2};
    color: ${({ theme }) => theme.background2};
    p {
      color: '#FFFFFF';
    }
    @media (max-width: 1000px) {
      width: 280px;
    }
    height: 40px;
    transition: 0.3s;
    background-color: ${({ theme }) => theme.font3};
  }
  p,  h1{
    width: 100%;
  }

  }
`;

export const CarrosselContainer = styled.div`
  position: relative;
  width: 1110px;
  overflow: hidden;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const CarrosselInner = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  gap: 1rem;
  width: 1100px;
  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const CarrosselItem = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  min-width: 100%;
  width: 400px;
  // border: 1px solid rgba(0, 0, 0, 0.75);
  border-radius: 3px;
  div {
    width: 100%;
    display: flex;
    justify-content: center;
    div {
      display: flex;
      // align-items: center;
      width: 200px;
    }
  }
  img {
    // border-right: 1px solid rgba(0, 0, 0, 0.75);
    width: 100%;
    height: 450px;
    object-fit: contain;
    @media (max-width: 900px) {
      height: auto;
    }
  }

  h3 {
    font-family: 'roboto Medium', sans-serif;
    font-size: 17px;
  }
  p {
    font-family: 'roboto Medium', sans-serif;
    font-size: 17px;
    color: #543530;
  }
  .azul {
    h3 {
      font-family: 'roboto Medium', sans-serif;
      font-size: 17px;
      color: #6f7c8f;
    }
  }
  .vermelho {
    h3 {
      font-family: 'roboto Medium', sans-serif;
      font-size: 17px;
      color: #a04330;
    }
  }
  .marrom {
    h3 {
      font-family: 'roboto Medium', sans-serif;
      font-size: 17px;
      color: #543530;
    }
  }
  .amarelo {
    h3 {
      font-family: 'roboto Medium', sans-serif;
      font-size: 17px;
      color: #e7a044;
    }
  }
`;

export const CarrosselText = styled.div`
  display: flex;
  // gap: 3rem;
  text-align: left; /* Centraliza o texto */

  img {
    width: 35px;
    filter: brightness(0) saturate(100%) invert(100%);
  }
  hr {
    width: 60px;
    height: 2px;
    background-color: #888888;
  }
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 150px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const CarrosselButtons = styled.div`
  // position: absolute;
  // top: 50%;
  display: flex;
  // width: 200px;

  justify-content: space-between;
  // transform: translateY(-50%);
  margin-top: 15px;
`;

export const CarrosselButton = styled.button`
  border: none;
  cursor: pointer;
  background-color: transparent; /* Fundo transparente */
`;

export const FloatingButton = styled.button`
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  background-color: transparent; /* Fundo transparente */
  img {
    border-right: none;
  }
`;
